import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from '@/router/routes'

Vue.use(VueRouter)

export const router = new VueRouter({
  mode: 'history',
  routes
})

router.afterEach(to => {
  const { title } = to.meta
  document.title = `Universal University ${title ? '• ' + title : ''}`
})
